/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyBuy\mobybuy_frontoffice\src\Content\Modals\ModalSellAgreement\ModalSellAgreement.tsx
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyBuy\mobybuy_frontoffice
 * Created Date: Tuesday September 17th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday September 17th 2024 4:26:05 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { MouseEventHandler, useEffect, useRef, useState } from "react";
import MyModal from "Content/Modals/MyModal";
import translator from "MultiLanguage/TranslationWrapper";
import styles from "Content/Modals/ModalSellAgreement/ModalSellAgreement.module.css";
import { Button } from "@mui/material";
import ModalConfirmation from "../ModalConfirmation/ModalConfirmation";
import Agreement from "Content/CreateAccount/Agreement/Agreement";
import { AgreementRefType } from "Types/user.type";
import UserService from "Services/Users/UserService";
import { useInteractiveHeader } from "Router/HeaderInteractionProvider";
import RouterPathResolver from "Config/Router/RouterPathResolver";
import { useLocation } from "react-router-dom";

type ModalCtaProps = {
    onClose: MouseEventHandler<HTMLDivElement>,
    closeModal: MouseEventHandler,
    themeColor: string;
};

export default function ModalSellAgreement(props: ModalCtaProps) {
    const [openModal, setOpenModal] = useState<boolean>(false);
    const [isOkay, setIsOkay] = useState<boolean>(false);
    const [isSendable, setIsSendable] = useState(false);
    const { userID, SetSellAgreement, SellAgreement } = useInteractiveHeader();
    const [show, setShow] = useState<boolean>(false);
    const location = useLocation();

    const agreementRef = useRef<AgreementRefType>({
        commercialCallTime: undefined,
        sellAgreementTime: undefined
    });

    useEffect(() => {
        if (location.pathname === RouterPathResolver.routeCgv.path)
            setShow(false);
        else
            setShow(!SellAgreement);
    }, [location, SellAgreement]);

    const handleCloseModals = (e: any) => {
        setOpenModal(false);
        props.closeModal(e);
    };

    const checkIsSendable = async () => {
        await new Promise(resolve => setTimeout(resolve, 100));
        if (agreementRef.current.sellAgreementTime)
            setIsSendable(true);
        else
            setIsSendable(false);
    };

    const HandleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        const input = {
            CommercialCallTime: agreementRef.current.commercialCallTime,
            SellAgreementTime: agreementRef.current.sellAgreementTime!
        };
        UserService.updateUser(userID, input).then(() => {
            SetSellAgreement(true);
            setIsOkay(true);
            setOpenModal(true);
        }).catch((error) => {
            setIsOkay(false);
            setOpenModal(true);
            console.error(error);
        });
    };

    return (
        <>
            <MyModal closeModal={props.closeModal} show={show} onClose={props.onClose} addCloseCross={false} footer={<Button disabled={!isSendable} variant="contained" onClick={HandleSubmit}>{translator.decode("dynamic.save")}</Button>} title={translator.decode("users.agreementRequired")} className={styles.modalCtaStyle} themeColor={props.themeColor} >
                <Agreement ref={agreementRef} onUpdate={checkIsSendable} />
            </MyModal>
            <ModalConfirmation show={openModal} onClose={handleCloseModals} closeModal={handleCloseModals} isOkay={isOkay} themeColor={""} />
        </>
    );
};
